'use client';

import ReactDOM from 'react-dom';

/**
 * Preload resources.
 */
function PreloadResources() {
  const assetPrefix = process.env.NEXT_ASSET_PREFIX;

  if (assetPrefix) {
    // prefetchDNS not in the types yet
    (ReactDOM as any).prefetchDNS(assetPrefix);
    (ReactDOM as any).preconnect(assetPrefix);
  }

  (ReactDOM as any).prefetchDNS('https://cdn.cookielaw.org');
  (ReactDOM as any).preconnect('https://cdn.cookielaw.org');

  return null;
}

export default PreloadResources;
